import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Col,
  Form,
  Input,
  Row,
  Space,
  Typography,
  Button,
  Checkbox,
  Radio,
} from "antd";

const { Title } = Typography;

export const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const leasingOptions = [
  "Putnička vozila",
  "Laka dostavna vozila do 3,5 tone",
  "Teška teretna vozila preko 3,5 tone",
  "Građevinske mašine",
  "Quad/Motocikli",
];

const EditBrandForm = ({ state: { brandToEdit }, actions }) => {
  const [form] = Form.useForm();
  const [brand, setBrand] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    actions.getSingleBrand(id);
  }, []);

  useEffect(() => {
    setBrand(brandToEdit);
  }, [brandToEdit]);

  const onFinishEditBrand = (values) => {
    const brandData = {
      name: values.brand,
      assetType: values.leasingOption,
      group: values.group,
    };
    actions.updateBrand(id, brandData);
  };

  return (
    brand && (
      <Space direction="vertical" className="p-8 w-full">
        <Title className="text-xl font-bold text-dark-blue ml-10">
          UREDI BRAND = {brand?.name}
        </Title>
        <Form
          initialValues={{
            remember: true,
          }}
          {...layout}
          form={form}
          name="basic"
          onFinish={onFinishEditBrand}
        >
          <Row>
            <Col span={12}>
              <Form.Item
                initialValue={brand?.name}
                colon={false}
                labelAlign="right"
                label="Naziv branda"
                name="brand"
                className="mb-10"
                rules={[
                  {
                    required: true,
                    message: "Unesite naziv branda!",
                  },
                ]}
              >
                <Input placeholder="Unesite naziv branda" />
              </Form.Item>

              <Title className="text-dark-blue text-[16px] font-normal ml-10">
                VRSTA LEASING PREDMETA
              </Title>
              <Space className="bg-brand-bg border border-dashed border-brand-border rounded-md pl-8 pt-6 mb-8 ml-10">
                <Form.Item
                  initialValue={brand?.assetType}
                  name="leasingOption"
                  rules={[
                    {
                      required: true,
                      message: "Izaberite leasing predmet!",
                    },
                  ]}
                >
                  <Checkbox.Group className="gap-2" options={leasingOptions} />
                </Form.Item>
              </Space>
              <Form.Item
                name="group"
                className="ml-10"
                initialValue={brand?.group}
                rules={[
                  {
                    required: true,
                    message: "Izaberite grupu!",
                  },
                ]}
              >
                <Radio.Group>
                  <Space direction="vertical">
                    <Radio value={"A"}>GRUPA A</Radio>
                    <Radio value={"B"}>GRUPA B</Radio>
                    <Radio value={"C"}>GRUPA C</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="text-sm text-white bg-light-blue font-medium w-[132px] rounded-sm border-light-blue shadow-sm mt-6 ml-10"
                >
                  SPREMI
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Space>
    )
  );
};

export default EditBrandForm;
